import router from '@/router'
import axios from 'axios'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

http.interceptors.request.use(
  (config) => {
    const jwt = localStorage.getItem('__access')
    if (jwt) {
      config.headers.authorization = `Bearer ${jwt}`
    }

    return config
  },
  (error) => {
    console.log(`Erro: ${error}`)
  }
)

http.interceptors.response.use(
  (res) => {
    return res
  },
  (err) => {
    if (err.response && err.response.status === 401) {
      router.push({ name: 'login' })
    }

    return Promise.reject(err)
  }
)

export { http }
